export const USER_KEY = {
    CURRENT_STAFF_EMAIL: 'currentStaffEmail',
    CURRENT_STUDENT_EMAIL: 'currentStudentEmail',
    CURRENT_PROGRAM_CODE: 'currentProgramCode',
    CURRENT_TEMPLATE_ID: 'currentTemplateId'
};

export const ACCESS_TO = {
    ADMIN_READER: 'PROGRAM_VIEW',
    ADMIN_EDITOR: 'STUDENT_EDIT_VIEW',
};


export const STUDENT_DEGREE = {
    PURSUING : 'REGISTERED [PURSUING]',
    GRADUATED : 'GRADUATED',
    NOT_YET_REGISTERED : 'NOT YET REGISTERED',
};

